export const config = {
  app: {
    version: 'V1.0',
    foot: '@gekogold 2026',
    local: true
  }
}

export var env = {};

if ( config.app.state ) {

  let src2024 = 'http://localhost:80/public/api/';
  let src2025 = 'http://localhost:80/public/api/';
  let src2026 = 'http://localhost:80/public/api_2026/';

  env = {
    api: {
      endpoint: {
        cert  : src2026 + 'CertClientApiInterface.php',
        auth  : src2026 + 'AuthClientApiInterface.php'
      }
    }
  }
} else {

  let src2024 = 'https://feed.gekogold.com/api/';
  let src2025 = 'https://feed.gekogold.com/api_2025/';
  let src2026 = 'https://api.c3rt.io/api/geko/';

  env = {
    api: {
      endpoint: {
        cert  : src2026 + 'CertClientApi.php',
        auth  : src2026 + 'AuthClientApi.php'
      }
    }
  }
}
